import React from "react"
import { Helmet } from "react-helmet"
import queryString from "query-string"
import SEO from "global/layout/Seo"
import { Button, TextField } from '@material-ui/core';
import {InstantWinController} from 'components/instant-win/InstantWinController'
import IframeMagick from "components/IframeMagick"
import { userContext, getProfile, getUserType } from "global/context/sub-contexts/userContext"
import { userTypeEnum } from 'services/user'


import Layout from "global/layout/Layout"


import HeroBanner from "components/index/HeroBanner"
import { LockedContent } from "./GuestSignUpTemplate"
import LandingStep from "steps/landing/LandingStep"
import SideNav from "steps/landing/SideNav"
import { registerGuest } from "services/auth"
import { getBreakStatus, scrollToTopOfCurrentStep } from "services/break"

import Step from "steps/Step"
import { supportedStepType as step3Supported, Step3} from "steps/Step3"

import analytics from "global/AnalyticsData"
import './ScrollingSponsoredTemplate.scss'

const supportedStepType = stepType => {
  let stepTypesSupported = ["PERSONALITY_QUIZ", "LISTICLE", "REFERRAL", "LEAD_GEN", "TEXT_TRIVIA", "FILTERING", "COMPLETE", "VIDEO", "REVIEW", "STORE_FINDER", "PINTEREST", "POLL", "UGC_PHOTO", "CUSTOM_HTML", "GROCERY", "RECEIPT_VERIFICATION", "STORE_FINDER", "MEMORY_MATCH", "REVIEW", "CUSTOM_JSON", "UGC_VIDEO", "GALLERY", "MEDIA_UPLOAD"]
  return stepTypesSupported.indexOf(stepType) >= 0
}

export class ScrollingSponsoredTemplate extends React.Component {
  constructor(props) {
    super(props)

    this.brk = props.pageContext.brk



    if (this.brk && this.brk.steps) {
      this.brk.steps = this.brk.steps.filter(step => {
        return supportedStepType(step.type)
      })
    }

    // steps don't maintain their own position, but we need it (mostly for analytics calls)
    this.brk.steps.forEach((step, i) => {
      step.position = i + 1
    })

    // for analytics
    // platform comes from the break object, but we no longer have a concept of a separate child for EMBED
    if (this.brk && props.pageContext.isEmbed) {
      this.brk.platform = "EMBED"
    }

    if (this.brk && !props.pageContext.isEmbed) {
      this.brk.shareUrl = ""
    }

    if (this.brk) {
      this.brk.permalink = this.brk.permaLink
    }

    // a map of step id to view count for this current page view
    // refreshing the page will reset this count
    this.stepViewCounts = {}
    if (this.brk && this.brk.steps) {
      this.stepViewCounts = this.brk.steps.reduce(function (viewCountMap, step) {
        viewCountMap[step.id] = 0
        return viewCountMap
      }, {})
    }

    //We don't want to trigger two of the same step view in a row.
    this.lastStepView = null

    let initializeStepStatusArr = []
    if (this.brk) {
      initializeStepStatusArr = (() =>
        this.brk.steps.reduce(function (arr, step, index) {
          // first step is unlocked
          if (index === 0) {
            arr.push({
              locked: false,
              complete: false,
              scrollComplete: false,
              skipped: false,
              id: step.id,
              type: step.type,
              position: index + 1,
              label: step.label,
            })
          } else {
            arr.push({
              locked: true,
              complete: false,
              scrollComplete: false,
              skipped: false,
              id: step.id,
              type: step.type,
              position: index + 1,
              label: step.label,
            })
          }
          return arr
        }, []))()
      // console.log(initializeStepStatusArr)
    }

    this.state = {
      currentStep: 0,
      stepStatusArr: initializeStepStatusArr,
      scrollingToPosition: null,
      stepLocked: this.brk.ageGate ? true : false,
      birthdate: "",
      ageGate: "ask",
      ageGateError: false
    }

    this.isLoggedIn = false
    this.userType = getUserType() // getUserType() pulls user info from local storage, not context. So we check it often.
    // TODO: stop using the variable and just call getUserType() everywhere

    this.observer = React.createRef()

    
    this.handleAuthRequired = this.handleAuthRequired.bind(this)
    this.handleAttemptStepStart = this.handleAttemptStepStart.bind(this)

    //Checks to see if urlparam is there for initial step to load. if not, scroll to first step
    this.getStepToLoad = () => {
      let theSteps = this.brk.steps
      return new Promise(function (res) {
        let position = 0 //default to 0; in this case scrolling will not occur
        try {
          let query = queryString.parse(window.location.search)
          if (query) {
            if (query.stepId) {
              
              //if user is returning to receipt verification step from reminder email
              let newPosition = theSteps.findIndex(item => {
                return item.id === query.stepId
              });
              if (!newPosition) {
                console.log(`stepId incorrect on query params. defaulting to first step`)
              } 
              position = newPosition
              if (position >= 0) {
                theSteps[position].startScreenDisabled = true
              }
              position = position + 1 //+1 for start step
              console.log(`found stepId in params. that step position is: ${position}`)
              res(position)
            }
            //if user is returning to receipt verification step to check submission
            else if (query.submissionId) {
              console.log(`found submission id. hiding start screen`)
              let theReceiptStepOnThisPage = theSteps.filter(item => {
                return item.type === "RECEIPT_VERIFICATION"
              })

              position = theSteps.findIndex(item => {
                return item.id === theReceiptStepOnThisPage[0].id
              })
              if (position >= 0) {
                theSteps[position].startScreenDisabled = true
              }
              position = position + 1 //+1 for start step
              console.log(`found submissionId in params. that step position is: ${position}`)
              res(position)
            }
            else {
              console.log(`no stepId or submissionId in query params`)
              res(0)
            }
          } else {
            console.log(`no query parameters`)
            res(0)
          }
          res(0)
        } catch (e) {
          //put a catch here because there's about 7 variables that could be undefined
          res(0)
        }
      })
    }
    this.getIsLocked = stepId => {
      if (stepId === "landing") {
        return false
      }

      let found = this.state.stepStatusArr.find(stepStatus => {
        return stepStatus.id === stepId
      })

      if (found) {
        // console.log(found)
        return found.locked
      } else {
        console.warn(`Unable to find step status for ${stepId}`)
        return true
      }
    }

    this.getIsComplete = stepId => {
      let found = this.state.stepStatusArr.find(stepStatus => {
        return stepStatus.id === stepId
      })

      if (found) {
        // console.log(found)
        return found.complete
      } else {
        console.warn(`Unable to find step status for ${stepId}`)
        return false
      }
    }

    this.getNextStep = previousStepId => {
      if (previousStepId === "landing") {
        return this.brk.steps[0]
      }

      let previousStepPosition = this.brk.steps.findIndex(item => {
        return item.id === previousStepId
      })

      if (previousStepPosition < this.brk.steps.length) {
        return this.brk.steps[previousStepPosition + 1]
      } else {
        return null
      }
    }

    this.getIsScrollComplete = stepId => {
      let found = this.state.stepStatusArr.find(stepStatus => {
        return stepStatus.id === stepId
      })

      if (found) {
        // console.log(found)
        return found.scrollComplete
      } else {
        console.warn(`Unable to find step status for ${stepId}`)
        return false
      }
    }

    this.triggerStepViewEventIfUnlocked = (stepId, stepPosition) => {
      if (stepId === "landing") {
        return
      }

      const triggerStepView = () => {
        this.stepViewCounts[stepId] = this.stepViewCounts[stepId] + 1

        let step = this.brk.steps.find(step => {
          return step.id === stepId
        })
        console.debug("step started")
        if (typeof window !== `undefined`) {
          if (this.lastStepView !== stepId) {
            this.lastStepView = stepId
            console.log("event: step_view: ", step.type)

            window.dataLayer.push({
              event: "step_view",
              break: {
                stepid: step.id,
                step_type: step.type,
                step_number: step.position,
              },
            })

            analytics.stepEvent("step_view", step)

            // special case for break_completion event
            // when Complete step is viewed it fires start, complete, and break_completion
            // we only want to trigger break_completion once per "page session"

            if (step.type === "COMPLETE" && this.stepViewCounts[stepId] === 1) {
              // console.log("It's my first time viewed: " + step.type)

              if (typeof window !== `undefined`) {
                console.log("event: break_completion")

                window.dataLayer.push({
                  event: "break_completion",
                })

                analytics.breakEvent("break_completion", this.brk)
              }
            }
          }
        }
      }

      const ifPrevStepIncompleteScrollCompleteIt = () => {
        //BR-1127 scroll into next step also triggers complete for prev step if scrolled step is unlocked
        let newStepStatusArr = this.state.stepStatusArr.slice()
        const indexOfPreviousStep = stepPosition - 2 //stepPosition starts at 1

        if (indexOfPreviousStep >= 0) {
          const prevStep = newStepStatusArr[indexOfPreviousStep]
          // console.log(prevStep)

          if (!prevStep.complete && !prevStep.locked) {
            this.scrollCompleteStep(prevStep.id)
          }
        }
      }

      if (!this.getIsLocked(stepId) && !this.props.pageContext.isEmbed) {
        ifPrevStepIncompleteScrollCompleteIt()
        triggerStepView()
      } else if (this.props.pageContext.isEmbed) {
        //embedded breaks have discrepancy between locked state and isLocked prop
        //we want step_view to fire on these 'locked' steps
        // ifPrevStepIncompleteScrollCompleteIt()
        triggerStepView()
      }
    }

    this.handleSideNavItemClick = ({ stepId, position }) => {
      if (typeof window !== `undefined`) {
        window.dataLayer.push({
          event: "side_nav_click",
        })
      }
      this.setState({
        currentStep: position,
        scrollingToPosition: position,
      })
      this.scrollToStep(position)
    }

    this.handleLandingStartClick = () => {
      this.userType = getUserType() // refresh it, just in case

      if (this.userType === userTypeEnum.NONE) {
        this.context.askToLogin()
      } else if (this.userType === userTypeEnum.GUEST && this.props.pageContext.isEmbed === false) {
        this.context.askToLogin()
      } else {
        this.setState({
          currentStep: 1,
          scrollingToPosition: 1,
        })

        this.scrollToStep(1)
      }
    }

    this.handleGoToNext = stepId => {
      console.debug("handleGoToNext " + stepId)

      if (!stepId) {
        console.error("Missing stepId parameter")
      }
      let step = this.brk.steps.find(step => {
        return step.id === stepId
      })

      let nextStepPosition = step.position + 1
      this.setState({
        currentStep: nextStepPosition,
        scrollingToPosition: nextStepPosition,
      })

      this.scrollToStep(nextStepPosition)
    }

    // Steps should fire onStepStart after they get a success from calling api /<step>/start .
    this.handleStepStart = (step, attempt = 1, isBreakEngagement = false) => {
      //Break_engagement is the first time this user interacts with break, and as of 7/1 the api checks this at every step start.
      console.log("ON Step START", step.type)
      this.stepStartDate = new Date()

      if (typeof window !== `undefined`) {
        if (isBreakEngagement) {
          console.log("event: break_engagement")
          window.dataLayer.push({
            event: "break_engagement",
          })

          analytics.breakEvent("break_engagement", this.brk)
        }

        if (step.id === this.brk.steps[0].id) {
          console.log("event: break_start")
          window.dataLayer.push({
            event: "break_start",
          })

          analytics.breakEvent("break_start", this.brk)
        }

        console.log("event: step_start: ", step.type)
        window.dataLayer.push({
          event: "step_start",
          break: {
            stepid: step.id,
            step_type: step.type,
            step_number: step.position,
          },
        })

        analytics.stepEvent("step_start", step, { attempt: attempt })
      }
    }

    this.handleStepComplete = completedStepId => {
      let step = this.brk.steps.find(step => {
        return step.id === completedStepId
      })

      if (typeof window !== `undefined`) {
        console.log("event: step_completion: ", step.type)
        window.dataLayer.push({
          event: "step_completion",
          break: {
            stepid: step.id,
            step_type: step.type,
            step_number: step.position,
          },
        })

        let now = new Date()
        var elapsed_time = Math.floor((now - this.stepStartDate) / 1000)

        analytics.stepEvent("step_completion", step, { elapsed_time: elapsed_time })
      }

      //BR-1127 since we decoupled stepStatus.complete from unlock,
      //need to put it here instead
      let newStepStatusArr = JSON.parse(JSON.stringify(this.state.stepStatusArr))
      newStepStatusArr.forEach((stepStatus, i) => {
        if (stepStatus.id === completedStepId) {
          stepStatus.complete = true

          // unlock the next step
          if (i < newStepStatusArr.length - 1) {
            newStepStatusArr[i + 1].locked = false
            // console.debug("unlocking next step: ")
            // console.debug(newStepStatusArr[i + 1])
          }
        }
      })

      if (JSON.stringify(this.state.stepStatusArr) !== JSON.stringify(newStepStatusArr)) {
        this.setState({
          stepStatusArr: newStepStatusArr,
        })
      }

      this.unlockNextStep(completedStepId)
    }

    this.unlockNextStep = stepId => {
      // console.debug("unlockNextStep " + stepId)
      let newStepStatusArr = JSON.parse(JSON.stringify(this.state.stepStatusArr))
      newStepStatusArr.forEach((stepStatus, i) => {
        if (stepStatus.id === stepId) {
          //BR-1127 decoupling this to allow complete event on scroll
          // stepStatus.complete = true

          // unlock the next step
          if (i < newStepStatusArr.length - 1) {
            newStepStatusArr[i + 1].locked = false
            // console.debug("unlocking next step: ")
            // console.debug(newStepStatusArr[i + 1])
          }
        }
      })

      if (JSON.stringify(this.state.stepStatusArr) !== JSON.stringify(newStepStatusArr)) {
        this.setState({
          stepStatusArr: newStepStatusArr,
        })
      }
    }

    this.handleStepSkip = step_id => {
      console.log("handleStepSkip")

      let step = this.brk.steps.find(step => {
        return step.id === step_id
      })

      if (typeof window !== `undefined`) {
        console.log("event: step_skip & completion: ", step.type)
        window.dataLayer.push({
          event: "step_skip",
          break: {
            stepid: step.id,
            step_type: step.type,
            step_number: step.position,
          },
        })

        window.dataLayer.push({
          event: "step_completion",
          break: {
            stepid: step.id,
            step_type: step.type,
            step_number: step.position,
          },
        })

        let now = new Date()
        var elapsed_time = Math.floor((now - this.stepStartDate) / 1000)

        analytics.stepEvent("step_skip", step, { elapsed_time: elapsed_time })
        analytics.stepEvent("step_completion", step, { elapsed_time: elapsed_time })
      }

      let newStepStatusArr = JSON.parse(JSON.stringify(this.state.stepStatusArr))
      newStepStatusArr.forEach((stepStatus, i) => {
        if (stepStatus.id === step_id) {
          newStepStatusArr[i].skipped = true
          newStepStatusArr[i].complete = true
        }
      })

      if (JSON.stringify(this.state.stepStatusArr) !== JSON.stringify(newStepStatusArr)) {
        this.setState({
          stepStatusArr: newStepStatusArr,
        })
      }

      this.unlockNextStep(step_id)
      this.handleGoToNext(step_id)
    }

    this.scrollCompleteStep = stepId => {
      let newStepStatusArr = JSON.parse(JSON.stringify(this.state.stepStatusArr))
      newStepStatusArr.forEach((stepStatus, i) => {
        if (stepStatus.id === stepId) {
          newStepStatusArr[i].scrollComplete = true
        }
      })

      if (JSON.stringify(this.state.stepStatusArr) !== JSON.stringify(newStepStatusArr)) {
        this.setState({
          stepStatusArr: newStepStatusArr,
        })
      }
    }

    this.handleAwardPoints = points => {
      const { setPoints } = this.context
      setPoints(points)
    }
  } // constructor

  scrollToStep = (position) => {

    try {
      let obj = document.querySelector(`.step-position-${position}`)
      obj && obj.scrollIntoView({ behavior: "smooth", block: "start" })
      console.log(`successfully scrolled to step-position-${position}`)
    } catch (e) {
      console.log(`problem in method scrollToStep(${position}): ${e}`)
    }

  }
  handleAuthRequired = () => {

    if (this.props.pageContext.isEmbed) {
        async function autoRegisterGuest() {
            try {
                const response = await registerGuest()
                this.context.setProfile(response.detail.user)
            } catch (e) {
                console.warn("handleGuest", e)
            }
        }
        autoRegisterGuest()

    } else {
        this.userType = getUserType()   // refresh it, just in case

        if (this.userType !== userTypeEnum.REGISTERED ) {
            this.context.askToLogin();
        }
    }

  }

  // BR-1469. Before starting, steps should make sure they're good to go
  // TODO: def some overlap with other code here.
  handleAttemptStepStart = async (stepId) => {
    console.log(`handleAttemptStepStart`)

    this.userType = getUserType()   // refresh it, just in case

    // non-embeddd breaks require people to be signed in
    if ((this.props.pageContext.isEmbed === false) && (this.userType !== userTypeEnum.REGISTERED)) {
        this.context.askToLogin()
        return false
    }

    if ((this.props.pageContext.isEmbed === true) && (this.userType === userTypeEnum.NONE) ) {
        // console.log("EMBED")
            try {
                const response = await registerGuest()
                // TODO check for a 200!
                this.context.setProfile(response.detail.user)
                return true
            } catch (e) {
                console.warn("embed register", e)
                return false
            }
    }

    return true

  }

  calculateDateOfBirth = () => {
    let minAge = this.brk.ageGate.min
    let maxAge = this.brk.ageGate.max
    let dob = Date.parse(this.state.birthdate)
    let diff = new Date(new Date() - dob);
    let age = diff.getFullYear() - 1970;

    if (age > minAge && age < maxAge) {
      this.setState({
        stepLocked: false,
        ageGate: "over21"
      })
    } else if (age < minAge) {
      this.setState({
        ageGate: "under21"
      })
    } else if (age > maxAge) {
      this.setState({
        ageGate: "overMax"
      })
    }
  }
  initIntersectionObserver = () => {
        // -------------------------
    // set up IntersectionObserver to determine if a step is in focus
    // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
    let intersectionObserverOptions = {
      threshold: 0.4, // 40% is visible on the page
    }

    // 1. create an observer
    this.observer.current = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        // TODO: setCurrentStep() here causes some jankyness when the user clicks in the sidenav.
        //       user clicks sidenav, causes page to scroll, then this listener gets triggered during scroll
        //
        // need to find a way to turn this off when the user click an item in the sidenav
        // (maybe clickng sidenav sets classnames that this can test for to ignore?)
        if (entry.isIntersecting) {
          // console.log(entry.target.dataset.steptype + ' ' + entry.target.dataset.stepid + ' ' + entry.target.dataset.position )
          if (this.state.scrollingToPosition == null) {
            this.setState({
              currentStep: parseInt(entry.target.dataset.position),
            })
          } else {
            if (parseInt(entry.target.dataset.position) === this.state.scrollingToPosition) {
              this.setState({
                scrollingToPosition: null,
              })
            }
          }

          console.log("triggerStepViewEventIfUnlocked " + entry.target.dataset.stepid)
          this.triggerStepViewEventIfUnlocked(entry.target.dataset.stepid, entry.target.dataset.position)

          return // only trigger once (in case something weird happens)
        }
      })
    }, intersectionObserverOptions)
    
    if (document.querySelector(`.step-landing`)) {
      // 2. tell that observer to watch the landing page
      this.observer.current.observe(document.querySelector(`.step-landing`))
    }

    // 3. tell the observer to watch all of our steps
    if (!this.state.stepLocked) {
      this.brk.steps.forEach(step => {
        this.observer.current.observe(document.querySelector(`.step-${step.id}`))
      })
    }
  }
  initUser = () => {
    this.userType = getUserType()   // refresh it, just in case

    if (this.userType === userTypeEnum.REGISTERED) {
        getBreakStatus(this.brk.id)
        .then(result => {
          // update our local stepStatusArr based on what the API knows
          if (result.success === true) {
            // console.log(stepStatusArr)

            let newStepStatusArr = JSON.parse(JSON.stringify(this.state.stepStatusArr))

            result.detail.forEach(apiItem => {
              newStepStatusArr.forEach((statusItem, index, theArray) => {
                if (apiItem.stepId === statusItem.id) {
                  if (apiItem.completeTime) {
                    theArray[index].complete = true
                    theArray[index].locked = false
                  }
                }
              })
            })

            // stepStatusArr now matches what the server knows
            // make sure the step after the last completed step is marked as unlocked
            let previousComplete = true
            newStepStatusArr.forEach((statusItem, index, theArray) => {
              if (previousComplete === true) {
                theArray[index].locked = false
              }
              if (theArray[index].complete !== true) {
                previousComplete = false
              }
            })

            if (JSON.stringify(this.state.stepStatusArr) !== JSON.stringify(newStepStatusArr)) {
              this.setState({
                stepStatusArr: newStepStatusArr,
              })
            }
          }
        })
        .catch(e => {
          if (e.message === "401") {
            console.log("can't get break status - user not signed in")
            if (this.context) {
              this.context.unauthorized()
            }
          } else {
            console.warn("BREAK STATUS ERROR")
            console.warn(e)
          }
        })
    } else {
        // user isn't logged in, but it's an embedded break, sign them in as a guest
        if (this.props.pageContext.isEmbed === true) {
            // console.log("EMBED")
            async function handleGuest() {
                try {
                    const response = await registerGuest()
                    this.context.setProfile(response.detail.user)
                } catch (e) {
                    console.warn("embed register", e)
                }
            }

            if (this.userType === userTypeEnum.NONE) {
                handleGuest.bind(this)()
            }

        } else {
            // not an embeddded break, ask the user to sign in
            this.context.unauthorized()
        }
    }

 
    console.log("isLoggedIn", this.isLoggedIn, this.userType)
 
  }
  componentDidMount() {
    this.initIntersectionObserver();
    this.initUser();

    analytics.setBreak(this.brk)
    analytics.setUser(getProfile())

    if (this.brk) { //does this actually happen?
      if (typeof window !== `undefined`) {
        console.log("event: break_view")

        window.dataLayer.push({
          event: "break_view",
          break: {
            platform: this.brk.platform,
            breaktitle: this.brk.title,
            breakid: this.brk.id,
            permalink: this.brk.permalink,
            break_type: this.brk.sponsoredType,
            challenge_id: this.brk.challengeId,
            step_total: this.brk.steps.length,
            language: this.brk.lang,
          },
        })

        analytics.breakEvent("break_view", this.brk)
      }
    }

   

    //Scroll to first step, or scroll to step specified in urlParams if it exists
    this.getStepToLoad().then((position) => {
      if (position > 0) {
        console.log(`Query string gave us the info we need to tell us we should scroll to step ${position}`)
        this.setState({
          currentStep: position,
          scrollingToPosition: position,
        })
        this.scrollToStep(position)
      } else {
        console.log("no query string detected, not scrolling to step")
      }
    })
  

  } // componentDidMount


  componentDidUpdate(prevProps, prevState) {
    console.log(`scrolling sponsored template updated: ${prevProps} ${prevState}`)  
    
    analytics.setUser(getProfile())

  }



  render() {
    // TODO: put this in the right place.
    let seoImage = `${process.env.SITE_ASSET_URL}/og_image.png` // TODO: need a better default

    if (this.brk.socialShareBadgeId) {
        seoImage = `${process.env.SITE_ASSET_URL}/${this.brk.socialShareBadgeId}_2x`
    }

    // theme settings from beaker 
    // TODO: centralize in smarter way, maybe in css variable
    // we don't currently have a setting for hover color. this :hover rule overrides dailybreak purple. 
    const inlineStyle = `
    .sponsored .themed-button,
    .sponsored .themed-button:hover {
        background-color : ${this.brk.themeColor3};
        color : ${this.brk.themeColor4};
        border-color : ${this.brk.themeColor3}; 
    }

    .sponsored .themed-button-secondary {
      background-color : transparent;
      color : ${this.brk.themeColor4};
      border : 2px solid ${this.brk.themeColor3}; 
    }

    .sponsored .themed-secondary {
      background-color : ${this.brk.themeColor5 ? this.brk.themeColor5 : "#EEEAF4"};
      color : ${this.brk.themeColor6 ? this.brk.themeColor6 : "#646464"};
    }


`
    // if valid, returns false (no errors)
    // if not valid, returns true (errors present)
    // probably could adjust the language around this 
    const validateDOB = () => {
      let birthdate = this.state.birthdate
      const pattern =/^([0-9]{1,2})\/([0-9]{1,2})\/([0-9]{4})$/;
      if (pattern.test(birthdate)) {
        return false
      } else {
        return true
      }
    }

    const errorHelperText = "Enter birthdate in the mm/dd/yyyy format please"

    // calculates the age based on the date of birth
    

    const handleDOBFormChange = (e) => {
      this.setState({birthdate: e.target.value})
    }

    const handleAgeGateFormSubmit = () => {
      this.calculateDateOfBirth()
      this.setState({
        ageGateError: validateDOB()
      })
      window.scrollTo({top: 0, behavior: 'smooth'})
    }

    const buttonValidationClass = validateDOB() ? "invalid" : "valid"

    const isDOBEmpty = this.state.birthdate.length < 6

    const ageGateForm = (
      <div>
        <TextField 
            name="Birthdate"
            label="Birthdate* (mm/dd/yyyy)"
            variant="filled"
            id="dateofbirth"
            value={this.state.birthdate}
            onChange={handleDOBFormChange}
            error={this.state.ageGateError}
            helperText={this.state.ageGateError && errorHelperText} 
            />
        <Button className={`btn herobtn themed-button ${buttonValidationClass}`} onClick={handleAgeGateFormSubmit} id="submitdob">Submit</Button>
      </div>
    )

    const ageGateContent = {
      ask: {
        title: this.brk.ageGateTitle ? this.brk.ageGateTitle : "Are you 21 or older?",
        text: this.brk.ageGateCopy ? this.brk.ageGateCopy : "Now, wait just a minute—enter your birthdate below to confirm you are 21 or older to continue. You must be of legal drinking age in order to view this content.",
        button: ageGateForm
      },
      under21: {
        title: this.brk.ageGateFailedTitle ? this.brk.ageGateFailedTitle : "You must be 21 or older to view this content",
        text: this.brk.ageGateFailedCopy ? this.brk.ageGateFailedCopy : "Unfortunately, you’re not of age to view this break, but why don’t you check out some other content we think you’d enjoy?",
        button: <a className="btn herobtn themed-button" id="backtohomepage" href={this.brk.ageGateFailedButtonUrl ? this.brk.ageGateFailedButtonUrl : "/"}>{this.brk.ageGateFailedButtonCopy ? this.brk.ageGateFailedButtonCopy : "Back to Homepage"}</a>
      },
      overMax: {
        title: `You must be younger to view this content`,
        text: `Unfortunately, you're too old to view this break, but why don't you check out some other content we think you'd enjoy?`,
        button: <a className="btn herobtn themed-button" id="backtohomepage" href="/">Back to Homepage</a>
      },
    }


    return this.brk ? (
      <>
        {this.props.pageContext.isEmbed && <IframeMagick />}
        <Layout hideNav={this.props.pageContext.isEmbed} hideFooter={this.props.pageContext.isEmbed}>
          <div id="fb-root"></div>
          <SEO title={this.brk.title}
                description={this.brk.description}
                lang={this.brk.lang}
                image={ seoImage }
                />
          {this.props.pageContext.isEmbed ? (
            <Helmet
              bodyAttributes={{
                class: `sponsored is-embed ${this.brk.permalink}`,
              }}
            />
          ) : (
            <Helmet
              bodyAttributes={{
                class: `sponsored no-embed ${this.brk.permalink}`,
              }}
            />
          )}
          <Helmet>
              <script>{`
              if (window.top && window.self !== window.top) {
                try {
                    document.body.style.setProperty('overflow', 'hidden');
                    document.documentElement.style.setProperty("overflow","auto");    
                } catch (e) {
                    console.warn(e)
                }

                setInterval(function() {
                    try {
                        window.top.postMessage({type: "RESIZE_INTERVAL", value: document.body.clientHeight}, '*');
                    } catch (e) {}
                }.bind(this), 500)
              }

              window.addEventListener("message", function(message) {
                  if (message.data.type === "PARENT_CONFIG") {
                    // console.log("PARENT_CONFIG", message.data.value)
                    document.documentElement.style.setProperty('--content-min-height', message.data.value.height + "px");
                    document.body.style.setProperty('--content-min-height', message.data.value.height + "px");
                    document.body.style.setProperty('--content-offset-top', "-" + message.data.value.offsetTop + "px");
                    }    
                });

   
`}</script>
          </Helmet>
          {/* TODO: it feels really dirty to pass the entire break, there's got to be a better way to inherit social share options. */}
          {this.state.stepLocked && this.state.ageGate === "under21" ? 
            <HeroBanner
              title={ ageGateContent.under21.title }
              text={ ageGateContent.under21.text }
              backgroundImageUrl = { this.brk.ageGateBackgroundImageId ? `${process.env.SITE_ASSET_URL}/${this.brk.ageGateBackgroundImageId}` : null }
              mobileBackgroundImageUrl = { this.brk.ageGateMobileBackgroundImageId ? process.env.SITE_ASSET_URL + this.brk.ageGateMobileBackgroundImageId : null }
              button={ ageGateContent.under21.button } /> 
            : this.state.stepLocked && this.state.ageGate === "overMax" ?
            <HeroBanner
              title={ ageGateContent.overMax.title }
              text={ ageGateContent.overMax.text }
              button={ ageGateContent.overMax.button } 
              backgroundImageUrl = { this.brk.ageGateBackgroundImageId ?  `${process.env.SITE_ASSET_URL}/${this.brk.ageGateBackgroundImageId}` : null }
              mobileBackgroundImageUrl = { this.brk.ageGateMobileBackgroundImageId ? process.env.SITE_ASSET_URL + this.brk.ageGateMobileBackgroundImageId : null }
              /> 
            
            : this.state.stepLocked && this.state.ageGate === "ask" ?
            <HeroBanner 
              title={ageGateContent.ask.title}
              text={ageGateContent.ask.text}
              button={ageGateContent.ask.button} 
              backgroundImageUrl = { this.brk.ageGateBackgroundImageId ?  `${process.env.SITE_ASSET_URL}/${this.brk.ageGateBackgroundImageId}` : null }
              mobileBackgroundImageUrl = { this.brk.ageGateMobileBackgroundImageId ? `${process.env.SITE_ASSET_URL}/${this.brk.ageGateMobileBackgroundImageId}` : null }
              /> 
            :
            <SideNav stepStatusStr={JSON.stringify(this.state.stepStatusArr)} onItemClicked={this.handleSideNavItemClick} brk={this.brk} activeStepPosition={this.state.currentStep} />

          }
          { this.brk.customCss &&
                <style dangerouslySetInnerHTML={{__html:this.brk.customCss }} />
          }
            <style dangerouslySetInnerHTML={{ __html: inlineStyle, }} />
            
            <InstantWinController
                brk={this.props.pageContext.brk}
                permalink={this.props.pageContext.brk.permalink}
                instantWinId={this.props.pageContext.brk.instantWinId}
                userType={getUserType()}
                render={(instantWinLoaded = false, instantWinModal, handleInstantWinEvent=null ) => {
                    return (
                        <>
                        <main className="sponsored">
                            {this.brk.steps.length > 1 ? (
                            <>
                                <div className="sponsored-flow-wrapper">
                                {this.brk.logoImageId && (
                                    <div className="upper-logo">
                                    <img src={`${process.env.SITE_ASSET_URL}/${this.brk.logoImageId}`} alt="" />
                                    </div>
                                )}
                                {this.state.stepLocked ? (
                                    <LockedContent label="Confirm to Unlock">
                                    <div id="step-0" className="step-landing step-position-0" data-position="0" data-stepid="landing" data-steptype="LANDING">
                                        <div key={`topper-0`} className={`step-topper step-topper-0 step-topper-landing-new`} style={{position: "absolute", marginTop: "var(--content-offset-top)"}} id={`step-0`} />
                                        <LandingStep path={"/break/" + this.brk.permaLink} brk={this.brk} onAttemptStart={this.handleAttemptStepStart} onStartClick={this.handleLandingStartClick} isEmbed={this.props.pageContext.isEmbed} hasLogo={this.brk.logoImageId ? true : false} />
                                    </div>
                                    </LockedContent>
                                ) : (
                                    <div id="step-0" className="step-landing step-position-0" data-position="0" data-stepid="landing" data-steptype="LANDING">
                                        <div key={`topper-0`} className={`step-topper step-topper-0 step-topper-landing-new`} style={{position: "absolute", marginTop: "var(--content-offset-top)"}} id={`step-0`} />
                                        <LandingStep path={"/break/" + this.brk.permaLink} brk={this.brk} onAttemptStart={this.handleAttemptStepStart} onStartClick={this.handleLandingStartClick} isEmbed={this.props.pageContext.isEmbed} hasLogo={this.brk.logoImageId ? true : false} />
                                    </div>
                                )}
                                
                                
                                </div>
                                
                                {!this.state.stepLocked && this.brk.steps.map((step, i) => {
                                
                                    const startScreenDisabled = step.startScreenDisabled || false;

                                    if (step3Supported(step.type)) {
                                        return (
                                            <div key={i} className={`step-3-template sponsored-flow-wrapper step-${step.id} step-position-${i + 1}`} data-position={i + 1} data-stepid={step.id} data-steptype={step.type} >
                                                <div key={`topper-${i}`} className={`step-topper step-topper-${i + 1} step-topper-${step.id}`} style={{position: "absolute", marginTop: "var(--content-offset-top)"}} id={`step-${i+1}`} />

                                                <Step3
                                                    key={i}
                                                    brk={this.brk}
                                                    step={step}
                                                    breakId={this.brk.id}
                                                    stepId={step.id}
                                                    isComplete={this.getIsComplete(step.id)}
                                                    isLocked={!this.props.pageContext.isEmbed && this.getIsLocked(step.id)}
                                                    onGoToNext={this.handleGoToNext}
                                                    onStepStart={this.handleStepStart}
                                                    onStepComplete={this.handleStepComplete}
                                                    unlockNextStep={this.unlockNextStep}
                                                    onStepSkip={this.handleStepSkip}
                                                    isEmbed={this.props.pageContext.isEmbed}
                                                    scrollComplete={this.getIsScrollComplete(step.id)}
                                                    onAuthRequired={this.handleAuthRequired}
                                                   
                                                    handleAwardPoints={this.handleAwardPoints}
                                                    onAttemptStepStart={this.handleAttemptStepStart}
                                                    startScreenDisabled={startScreenDisabled}
                                                    handleInstantWinEvent={handleInstantWinEvent}

                                                />
                                            </div>                                            
                                            )
                                    } else {
                                        return (
                                            <div key={i} className={`sponsored-flow-wrapper step-${step.id} step-position-${i + 1}`} data-position={i + 1} data-stepid={step.id} data-steptype={step.type} id={step.id}>
                                            <Step
                                                key={i}
                                                brk={this.brk}
                                                step={step}
                                                breakId={this.brk.id}
                                                stepId={step.id}
                                                isComplete={this.getIsComplete(step.id)}
                                                isLocked={!this.props.pageContext.isEmbed && this.getIsLocked(step.id)}
                                                onGoToNext={this.handleGoToNext}
                                                onStepStart={this.handleStepStart}
                                                onStepComplete={this.handleStepComplete}
                                                unlockNextStep={this.unlockNextStep}
                                                onStepSkip={this.handleStepSkip}
                                                isEmbed={this.props.pageContext.isEmbed}
                                                scrollComplete={this.getIsScrollComplete(step.id)}
                                                onAuthRequired={this.handleAuthRequired}
                                               
                                                handleAwardPoints={this.handleAwardPoints}
                                                startScreenDisabled={startScreenDisabled}
                                            />
                                            </div>
                                        )
                                    }

                                })}
                            </>
                            ) : (
                            this.brk.steps.length === 1 && <Step step={this.brk.steps[0]} brk={this.brk} />
                            )}
                        </main> 
                        { instantWinModal }
                        </>
                    )
                }}
            />
 

        </Layout>
      </>
    ) : (
      <></>
    )
  }
}

// ScrollingSponsoredTemplate.contextType = GlobalDailybreakContext     // TODO: BUG in how we implement context OR how I'm trying to use it
ScrollingSponsoredTemplate.contextType = userContext // <-- this works  ^-- previous line does not



export default ScrollingSponsoredTemplate
